import * as util from "util";

import * as ansi_colors from "ansi-colors";

// import * as dateTimeHelper from "./CsDateTimeHelper";
import * as jsonHelper from "./CsJsonHelper";
import * as xmlHelper from "./CsXmlHelper";

export enum LogLevelEnum {
  Normal = "normal",
  Debug = "debug",
}

export enum LogMessageTypeEnum {
  Info,
  DebugInfo,
  Warning,
  Error,
}

// enum LogDestinationEnum {
//   Console = "console",
//   // File = "file",
//   // ConsoleAndFile = "console-and-file",
// }

const _infoMessagePrefix = "\nINFO    Message";
const _infoObjectPrefix = "\nINFO    Object ";

const _debugMessagePrefix = "\nDEBUG   Message";
const _debugObjectPrefix = "\nDEBUG   Object ";

const _warningMessagePrefix = "\nWARNING Message";
const _warningObjectPrefix = "\nWARNING Object ";

const _errorMessagePrefix = "\nERROR   Message";
const _errorObjectPrefix = "\nERROR   Object ";

export async function logAsync(
  logMessageTypeEnum: LogMessageTypeEnum,
  isDebugging: boolean,
  caller: string,
  methodName: string,
  logMessage: string,
  logObject: any
): Promise<boolean> {
  const localCaller = caller + ".logHelper.logAsync() v2";

  return new Promise(async function (resolve, reject) {
    let logMessageToConsole: string = "";
    let logObjectToConsole: any = null;

    try {
      //HACK: TODO: enable again!
      // const selectedLogLevel: LogLevelEnum = isDebugging
      //   ? LogLevelEnum.Debug
      //   : LogLevelEnum.Normal;

      //HACK: TODO: remove!
      const selectedLogLevel: LogLevelEnum = LogLevelEnum.Normal;

      switch (selectedLogLevel) {
        case LogLevelEnum.Normal:
          switch (logMessageTypeEnum) {
            // case LogMessageTypeEnum.Info:
            case LogMessageTypeEnum.Warning:
            case LogMessageTypeEnum.Error:
              logMessageToConsole = logMessage;
              if (logObject != null) {
                logObjectToConsole = logObject;
              }
              break;
            default:
              //Do nothing intentionally
              break;
          }
          break;
        //HACK: TODO: enable again!
        // case LogLevelEnum.Debug:
        //   logMessageToConsole = logMessage;
        //   if (logObject != null) {
        //     logObjectToConsole = logObject;
        //   }
        //   break;

        default:
          break;
      }

      const mustLogMessage: boolean = logMessageToConsole.length > 0;
      const mustLogObject: boolean = logObjectToConsole != null;

      if (mustLogObject) {
        if (xmlHelper.isXMLString(logObjectToConsole)) {
          logObjectToConsole = xmlHelper.formatXMLString(logObjectToConsole);
        } else if (jsonHelper.isJsonString(logObjectToConsole)) {
          logObjectToConsole = jsonHelper.formatJsonString(logObjectToConsole);
        } else {
          logObjectToConsole = util.inspect(logObjectToConsole, {
            depth: null,
            colors: true,
            compact: false,
          });
        }
      }

      if (mustLogMessage || mustLogObject) {
        await logToConsoleAsync(
          methodName,
          localCaller,
          logMessageTypeEnum,
          logMessageToConsole,
          logObjectToConsole
        );
      }

      return resolve(true);
    } catch (err) {
      return reportError(getErrorMessage(err));
    }
  });
}

function getErrorMessage(error: unknown) {
  if (error instanceof Error) return error.message;
  return String(error);
}

async function logToConsoleAsync(
  methodName: string,
  caller: string,
  logMessageTypeEnum: LogMessageTypeEnum,
  logMessageToOutput: string,
  logObjectToOutput: any
): Promise<boolean> {
  return new Promise(async function (resolve, reject) {
    try {
      const currentDateTimeISOString = new Date(Date.now()).toISOString();
      const mustLogMessage: boolean = logMessageToOutput.length > 0;
      const mustLogObject: boolean = logObjectToOutput != null;

      if (mustLogMessage || mustLogObject) {
        switch (logMessageTypeEnum) {
          case LogMessageTypeEnum.Info:
            if (mustLogMessage) {
              console.log(
                ansi_colors.bold.grey(_infoMessagePrefix) +
                ansi_colors.grey(" | ") +
                ansi_colors.white(currentDateTimeISOString) +
                ansi_colors.bold.gray(" | ") +
                ansi_colors.white(methodName) +
                ansi_colors.bold.gray(" | ") +
                ansi_colors.white(caller) +
                ansi_colors.bold.gray(" | ") +
                ansi_colors.bold.cyan(logMessageToOutput)
              );
            }
            if (mustLogObject) {
              console.log(
                ansi_colors.bold.grey(_infoObjectPrefix) +
                ansi_colors.grey(" | ") +
                ansi_colors.white(currentDateTimeISOString) +
                ansi_colors.bold.gray(" | ") +
                ansi_colors.white(methodName) +
                ansi_colors.bold.gray(" | ") +
                ansi_colors.white(caller) +
                ansi_colors.bold.gray(" | ") +
                ansi_colors.bold.cyan(logObjectToOutput)
              );
            }
            break;
          case LogMessageTypeEnum.DebugInfo:
            if (mustLogMessage) {
              console.log(
                ansi_colors.bold.blue(_debugMessagePrefix) +
                ansi_colors.grey(" | ") +
                ansi_colors.white(currentDateTimeISOString) +
                ansi_colors.grey(" | ") +
                ansi_colors.white(methodName) +
                ansi_colors.bold.gray(" | ") +
                ansi_colors.white(caller) +
                ansi_colors.bold.gray(" | ") +
                ansi_colors.bold.cyan(logMessageToOutput)
              );
            }
            if (mustLogObject) {
              console.log(
                ansi_colors.bold.blue(_debugObjectPrefix) +
                ansi_colors.grey(" | ") +
                ansi_colors.white(currentDateTimeISOString) +
                ansi_colors.grey(" | ") +
                ansi_colors.white(methodName) +
                ansi_colors.bold.gray(" | ") +
                ansi_colors.white(caller) +
                ansi_colors.bold.gray(" | ") +
                ansi_colors.bold.cyan(logObjectToOutput)
              );
            }
            break;
          case LogMessageTypeEnum.Warning:
            if (mustLogMessage) {
              console.log(
                ansi_colors.bold.yellow(_warningMessagePrefix) +
                ansi_colors.grey(" | ") +
                ansi_colors.white(currentDateTimeISOString) +
                ansi_colors.grey(" | ") +
                ansi_colors.white(methodName) +
                ansi_colors.bold.gray(" | ") +
                ansi_colors.white(caller) +
                ansi_colors.bold.gray(" | ") +
                ansi_colors.bold.cyan(logMessageToOutput)
              );
            }
            if (mustLogObject) {
              console.log(
                ansi_colors.bold.yellow(_warningObjectPrefix) +
                ansi_colors.grey(" | ") +
                ansi_colors.white(currentDateTimeISOString) +
                ansi_colors.grey(" | ") +
                ansi_colors.white(methodName) +
                ansi_colors.bold.gray(" | ") +
                ansi_colors.white(caller) +
                ansi_colors.bold.gray(" | ") +
                ansi_colors.bold.cyan(logObjectToOutput)
              );
            }
            break;
          case LogMessageTypeEnum.Error:
            if (mustLogMessage) {
              console.log(
                ansi_colors.bold.red(_errorMessagePrefix) +
                ansi_colors.grey(" | ") +
                ansi_colors.white(currentDateTimeISOString) +
                ansi_colors.grey(" | ") +
                ansi_colors.white(methodName) +
                ansi_colors.bold.gray(" | ") +
                ansi_colors.white(caller) +
                ansi_colors.bold.gray(" | ") +
                ansi_colors.bold.cyan(logMessageToOutput)
              );
            }
            if (mustLogObject) {
              console.log(
                ansi_colors.bold.red(_errorObjectPrefix) +
                ansi_colors.grey(" | ") +
                ansi_colors.white(currentDateTimeISOString) +
                ansi_colors.grey(" | ") +
                ansi_colors.white(methodName) +
                ansi_colors.bold.gray(" | ") +
                ansi_colors.white(caller) +
                ansi_colors.bold.gray(" | ") +
                ansi_colors.bold.cyan(logObjectToOutput)
              );
            }
            break;
          default:
            break;
        }
      }

      return resolve(true);
    } catch (err) {
      return reportError(getErrorMessage(err));
    }
  });
}

// export async function logStartMessageToConsoleAsync(
//   methodName: string,
//   caller: string
// ): Promise<boolean> {
//   const localCaller = caller + ".logHelper.logStartMessageToConsoleAsync()";

//   return new Promise(async function (resolve, reject) {
//     try {
//       const result: boolean = await logAsync(
//         methodName,
//         localCaller,
//         "STARTED",
//         null,
//         LogMessageTypeEnum.Info
//       );
//       return resolve(result);
//     } catch (err) {
//       return reject(new Error(err));
//     }
//   });
// }

// export async function logEndMessageToConsoleAsync(
//   methodName: string,
//   caller: string
// ): Promise<boolean> {
//   const localCaller = caller + ".logHelper.logEndMessageToConsoleAsync()";

//   return new Promise(async function (resolve, reject) {
//     try {
//       await logAsync(
//         methodName,
//         localCaller,
//         "FINISHED",
//         null,
//         LogMessageTypeEnum.Info
//       );

//       return resolve(true);
//     } catch (err) {
//       return reject(new Error(err));
//     }
//   });
// }
